// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@libs/apiUrl.js"; // 最开始修改baseGate变量
Vue.component("zg-select", zgSelect);
import zgSelect from "./publicElement/zg-compoundSelect"; //复合选择器
import "./components/libs/permission/permission.js"; //进度条
import Vue from "vue";
import App from "./App";
import lButton from "./components/button/button.vue"; //全局单次点击按钮
import lSort from "./publicElement/arrowSort";
import inputAmount from "./components/input/inputAmount.vue"; //全局金额输入框
import inputNumber from "./components/input/inputNumber.vue"; //全局数值输入框
import textAmount from "./components/text/textAmount.vue"; //全局组件 金额文本格式显示

import lImgdig from "./publicElement/imgDig.vue";
import lEmpty from "./publicElement/emptyTable";
import crumbs from "./publicElement/crumbs";
import { mixin } from "./components/libs/mixs.js";
import zgDrawer from "./publicElement/zg-drawer"; //侧滑框
import zgMask from "./publicElement/zg-mask"; //侧滑框
import zgElMask from "./publicElement/zg-el_mask"; //侧滑框
import showPicComponent from "./publicElement/fullImg/index";
Vue.use(showPicComponent);
import Reduce from "./components/libs/compress";
import { showCityInfo } from "./components/libs/getCity";
import store from "./store/index";

import "./components/libs/css/common.less";
import "./components/libs/css/common_2.less";
import "./components/libs/css/pagination.less";
import "./components/libs/sessionstorage.js";

import "./components/libs/dialogDrag.js"; // v-dialogDrag 弹窗拖拽属性
//文章编辑器
import VueQuillEditor from "vue-quill-editor";
Vue.use(VueQuillEditor);
// 字体   去index.html 里面改链接
// import './components/libs/font/iconfont.css'

// import 'element-ui/lib/theme-chalk/display.css';

import ElementUI from "element-ui";

// import './components/libs/css/theme.scss'

import fullLoading from "./publicElement/loading/index";
Vue.use(fullLoading);

// import 'vue-transition.css/transition.min.css' //transition 动画

import VueHighlightJS from "vue-highlightjs"; //代码高亮插件
import "highlight.js/styles/atom-one-dark.css";
Vue.use(VueHighlightJS);
Vue.use(ElementUI);
// 自定义加载更多指令
import directives from "./components/setMigration/acquisitionProgress/components/index";
Vue.use(directives);

// 自定义指令
import { focus } from "./components/libs/directive.js";
// 加载顺序错误,会导致样式错乱
import router from "./router";
import pigCommonDetails from "@pig-web/invice-web";
let arr = Object.keys(pigCommonDetails);
arr.forEach((key) => {
  if (pigCommonDetails[key] && pigCommonDetails[key].name) {
    Vue.component(pigCommonDetails[key].name, pigCommonDetails[key]);
  }
});
// vue全局点击回调
Vue.prototype.globalClick = function (callback) {
  document.querySelector("body").onclick = callback;
};
Vue.prototype.globalClickTwo = function (callback) {
  document.querySelector("#app").onclick = callback;
};
// 事件公车bug总线
Vue.prototype.$bus = new Vue();
Vue.prototype.$bus.defaultsBus = {
  spec: null,
};
//定位城市
Vue.prototype.GetCity = showCityInfo;
//压缩方法全局
Vue.prototype.reduce = Reduce;
//监听元素宽、高变化
import "./utils/resize.js";
// 全局引入自定义指令点击元素外关闭弹窗
import "./utils/direactive.js";
import dateSelect from "./publicElement/date-select"; //复合选择器
//全局组件 table  缺省
Vue.component("l-empty", lEmpty);
Vue.component("date-select", dateSelect);
//全局组件 查看图片
Vue.component("l-imgdig", lImgdig);
//全局组件 按钮防二次点击
Vue.component("l-button", lButton);
//全局组件 面包屑
Vue.component("crumbs", crumbs);
//全局组件 表格 排序
Vue.component("l-sort", lSort);
//全局组件 输入框
Vue.component("input-amount", inputAmount);
Vue.component("input-number", inputNumber);
//全局组件 金额文本格式显示
Vue.component("text-amount", textAmount);
// 全局组件  侧滑弹框
Vue.component("zg-drawer", zgDrawer);
Vue.component("zg-mask", zgMask);
Vue.component("zg-el-mask", zgElMask);
//全局组件 自定义 日期选择  有两种禁用
import llpicker from "./components/libs/date-picker/index.js"; //全局两种时间禁用
Vue.component("l-picker", llpicker);
// ajax
import axios from "axios";
import upload from "./utils/upload";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import { picway, interPictures } from "./components/libs/constant/constant.js";
import { previewImgBase } from "./components/libs/constant/constant.js";
//图片前缀
Vue.prototype.defaults = {};
Vue.prototype.defaults.interPictures = interPictures; //joolgo上的 网络图片
Vue.prototype.defaults.imgBaseURL = picway;
Vue.prototype.defaults.previewImgBase = previewImgBase;
Vue.prototype.$upload = new upload(axios);

// 网关
import { gateway } from "./components/libs/constant/constant.js";
//process.env.API_ROOT
Vue.prototype.defaults.baseURL = picway;
Vue.prototype.defaults.timeout = 200000; //请求超时
// Vue.axios 全局配置
Vue.axios.defaults.baseURL = "/api"; //注释后设置代理
// Vue.axios.defaults.baseURL = window.baseGate.ApiUrl;//注释后设置代理
// 请求拦截

import {
  enumReasult,
  clearAllCookie,
} from "@/components/libs/js/enumReasult.js";
Vue.axios.interceptors.request.use(
  function (config) {
    clearAllCookie(); //清除所有cookie 避免项目更新频繁 浏览器和服务器 对不上
    if (!config.noHeader) {
      config.headers["x-platform-source"] = 21;
      if (
        window.LS.get("token") &&
        !config.url.includes("tax-platform-table") &&
        !config.url.includes("tax-platform-business")
      ) {
        config.headers["Authorization"] = `Bearer ${JSON.parse(
          window.LS.get("token")
        )}`; // 让每个请求携带自定义token 请根据实际情况自行修改
      }
      config.headers["x-shop-version-id"] = window.LS.get("appId");
      config.headers["x-corp-id"] = window.LS.get("corpId");
      config.headers["x-merchant-id"] = window.LS.get("corpId");
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
// 响应拦截

import { whiteCode } from "@/components/libs/constant/constant";
import {
  setCrumbText,
  getMeau,
  getMeau1,
} from "@/components/libs/js/crumbs.js";
import { taxHeaderSet } from "@/components/libs/js/taxHeader.js";
import { unusualInteface } from "./components/libs/http/I_ajax.js";
Vue.axios.interceptors.response.use(
  function (response) {
    if (response.config.interface) {
      //新接口错误提示
      enumReasult(response.data);
    }
    // if(response.data && !whiteCode(response.data.code)){ //错误接口 穿给后端
    //   unusualInteface(Vue.axios,response)
    // }
    return response;
  },
  function (error) {
    if (!error.response) return;
    if (error.response.status == 401) {
      // todo
      if (Vue.prototype.defaults.Notification) return;
      // 要加再次刷新token机制
      Vue.prototype.defaults.Notification = new Vue().$notify.error({
        title: "错误",
        message: "未授权请重新登录，稍后自动返回",
        duration: 2000,
      });
      setTimeout(() => {
        Vue.prototype.defaults.Notification = null;
        window.LS.clear(); //清除 localStorage
        router.push("/login");
      }, 2000);
    } else {
      if (error.request.responseType === "blob") {
        var reader = new FileReader();
        reader.readAsText(error.response.data, "utf-8");
        reader.onload = function (res) {
          let result = JSON.parse(res.target.result || {});
          new Vue().$notify.error({
            title: "错误",
            message: result.message,
            duration: 2000,
          });
        };
        return;
      }
      let a = /.*[\u4e00-\u9fa5]+.*$/;
      // 其他的还是弹出来吧
      // 账套区域未分配错误处理
      if (error.response.data.message) {
        new Vue().$notify.error({
          title: "错误" + error.response.status,
          message: "服务器错误" + error.response.data.message,
          duration: 2000,
        });
      }
    }
    return Promise.reject(error);
  }
);
import themeList from "@libs/css/style.js";
Vue.config.productionTip = false;
/* eslint-disable no-new */
const whiteList = [
  "/login",
  "/register",
  "/WXlogin",
  "/loginnew",
  "/WXbind",
  "/find",
  "/rulesShow",
]; //  白名单
router.beforeEach((to, from, next) => {
  // mateCrumbsText
  taxHeaderSet(to, from, setCrumbText,router); //设置东西

  store.commit("setCompanyShow", to.meta.store || false); //老东西了 不知道干什么的
  //window.LS.set("company",JSON.stringify(to.meta.store||true));

  // 加一个判断是否有地址token
  if (
    (window.LS.get("SY") &&
      JSON.stringify(JSON.parse(window.LS.get("SY")).corp) != "{}") ||
    to.meta.rule ||
    (to.query.token && to.path == "/workSpace")
  ) {
    // 登录了且有公司  或者是在规则中心
    next();
  } else if (whiteList.includes(to.path)) {
    // 未登录 在白名单
    next();
  } else {
    // 未登录 也不在白名单
    // next("/login");
  }
});

// 试用接口
/* 主题 跳转页面判断皮肤换肤*/
let themeName = window.LS.get("themeName") || "绀青";
mixin.methods.setStyleRoot(themeName, themeList);

new Vue({
  el: "#app",
  store,
  router,
  components: {
    App,
  },
  template: "<App/>",
});
